<template>
  <div>
    <nav-bar
      :pageName="pageName"
      :sidebarIsOpen="sidebarIsOpen"
      @toggle-nav="toggleSidebar"
    />

    <div class="main-container">
      <side-bar
        :menu="menu"
        :sidebarIsOpen="sidebarIsOpen"
        @toggle-sidebar="toggleSidebar"
      />
      <main-content :sidebarIsOpen="sidebarIsOpen">
        <router-view />
      </main-content>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/Management/NavBar";
import SideBar from "@/components/Management/Sidebar/Sidebar";
import MainContent from "@/components/Management/Content";
import NoPermissionsPage from "./NoPermissionsPage";

export default {
  name: "ManagementPage",

  props: ["pageName", "menu"],

  components: {
    NoPermissionsPage,
    NavBar,
    SideBar,
    MainContent
  },

  data() {
    return {
      /**
       * Determines if sidebar is open
       */
      sidebarIsOpen: true
    };
  },

  methods: {
    /**
     * Toggles the value of the sidebarIsOpen variable to the opposite it has at the moment
     */
    toggleSidebar() {
      this.sidebarIsOpen = !this.sidebarIsOpen;
    }
  }
};
</script>

<style scoped>
.main-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #fafbfc;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/Management.vue